<template>
  <div class="tw-w-full">
    <input
      v-model="localReference"
      @input="handleInput"
      :placeholder="t('payment.titles.enter_invoice_number')"
      class="tw-w-full tw-px-2 tw-py-1 tw-border tw-rounded tw-text-sm"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { debounce } from 'lodash';

const { t } = useI18n();

const props = defineProps({
  payment: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['reference-changed']);

const localReference = ref(props.payment.invoice_number || '');

const handleInput = debounce(() => {
  emit('reference-changed', props.payment.id, localReference.value);
}, 300);

watch(
  () => props.payment.invoice_number,
  newValue => {
    localReference.value = newValue || '';
  }
);
</script>
